import { isUndefined } from "lodash";
import { store } from "redux/store";
import { includeAboveProperty } from "utils/CommonConstants";
import { getHltInncodes, getUserTypeValue } from "utils/CommonFunctions";
import { assignmentOptions } from "./DetailsAndConfirmation";
import { fetchPlanAssignmentPreviewAsync, setAssignmentFlow, setCurrentStep } from "./PlanAssignment.slice";

const getNotAvailableReason = (id: string, previewList: any) => {
  const notAvailableReason = previewList?.find((item: any) => item.id === id)?.notAvailableReason;
  return notAvailableReason;
};

export const getAssignmentPayload = (
  { isTemplatePlan, userSelectionFlow, source, isAssignCopy }: any,
  previewList?: any
) => {
  const { payloadData } = store.getState().PlanAssignment;
  const { isCorp, isConsultant } = store.getState().app.loggedInUserDetails;
  const plansKey = isAssignCopy ? "myPlans" : isTemplatePlan ? "templatePlans" : "libraryPlans";
  const commonData = {
    [plansKey]: payloadData.plans.map((plan: any) => {
      let obj: any = {
        id: plan?.id,
        title: plan?.name || plan?.title,
        dueDate: plan.dueDate || plan.brandDeadlines?.[0]?.["deadline"]
      };
      if (previewList?.length > 0) {
        obj = { ...obj, notAvailableReason: getNotAvailableReason(plan?.id, previewList) };
      }
      return obj;
    }),
    message: payloadData.message,
    assignmentPreference: assignmentOptions.find((item: any) => item.val === payloadData.assignmentPreference)?.id,
    source
  };

  const payload =
    isConsultant && userSelectionFlow !== "fourth"
      ? {
          mappingIds: payloadData.users.mappings,
          ...commonData
        }
      : {
          inncodeUsers: payloadData.users.map((item: any) => {
            return { inncode: item?.inncode || item?.innCode || item?.innCodes?.[0], hltId: item.hltId };
          }),
          ...commonData
        };

  return payload;
};

export const shouldDisplayPreview = async (
  dispatch: any,
  flow: any,
  payload: any,
  inncodes = [],
  isPlanProgress: string,
  planMeta: any
) => {
  const { currentStep, isAllMemberSelected, memberSelection, unselecteMember } = store.getState().PlanAssignment;
  const filters = store.getState().PlanAssignment.memberSelection.filters;
  const { propertyList } = store.getState().aboveProperty;
  const { brand, region } = store.getState().PlanAssignment.planSelection.filters;
  const mappedDelectedMember = unselecteMember?.map((data: any) => {
    return { inncode: data.innCodes[0], hltId: data.hltId };
  });
  const { inncodeUsers, ...restPayload } = payload;
  const meta = isPlanProgress ? planMeta : {};
  const modifiedPayload = isAllMemberSelected
    ? {
        ...restPayload,
        deSelectedInncodeUsers: mappedDelectedMember,
        userSearchInternalRequest: {
          ignoreNonFilteredInnCodes: true,
          respondWithHltIdAndInnCode: true,
          includecorpusers: false,
          roles: memberSelection?.filters?.role,
          searchText: memberSelection?.filters?.searchText,
          innCodes: inncodes?.length
            ? inncodes
            : filters?.property?.length
            ? filters.property
            : !isUndefined(getHltInncodes(true))
            ? getHltInncodes(true)?.split(",")
            : [],
          userType: getUserTypeValue(memberSelection?.filters[includeAboveProperty]),
          ...(meta?.brandCodes?.length ? { brandCodes: meta.brandCodes } : brand?.length ? { brandCodes: brand } : {}),
          ...(meta?.regions?.length
            ? { regions: meta.regions?.join("::") }
            : region?.length
            ? { regions: region?.join("::") }
            : {}),
          ...(meta?.locationTypes?.length ? { locationTypes: meta.locationTypes } : {}),
          ...(meta?.innCodes?.length ? { tgInnCodes: meta.innCodes } : {}),
          ...(meta?.managementTypes?.length ? { mgmtTypes: meta.managementTypes } : {})
        },
        isAllUsersSelected: true
      }
    : payload;
  const response = await dispatch(fetchPlanAssignmentPreviewAsync(modifiedPayload));
  dispatch(setAssignmentFlow({ flow: `${flow || "first"}`, withPreview: response.payload.plansNotAvailable?.length }));
  dispatch(setCurrentStep(currentStep + 1));
};
